<script type="text/ecmascript-6">
    import DesignerQuestionFrameColourExternal from "../DesignerQuestionFrameColourExternal.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionFrameColourExternal,
            SynsealTileQuestion
        ],
        props: {
            frameMaterial: {
                required: false,
                default(){
                    return '1';
                }
            },
            doorColour: {
                required: true,
            },
            slab: {
                required: true,
            },
            profile: {
                required: true,
            }
        },
        computed: {
            filtered_option_list(){
                if (this.option_list === null || !Array.isArray(this.option_list)) {
                    return [];
                }

                return this.option_list.filter((key)=> {
                    return key.value !== null && !!key.value;
                });
            },
            thumbURL(){
                return '/thumb/frame-colour-' + this.frameMaterial + '/';
            },
            passed_filter(){
                return this.variable_ready(this.frameMaterial, this.slab, this.profile);
            },
            url(){
                return '/api/options/' + this.fabricator + '/frame-colour-external?frame_material=' + this.frameMaterial + '&slab=' + this.slab + '&profile=' + this.profile;
            },
            cache_key(){
                return '_' + this.frameMaterial + '_' + this.slab + '_' + this.profile;
            },
        },
        watch: {
            'frameMaterial': function (val, oldVal) {
                this.update_options();
            },
            'target': function (val, oldVal) {
                this.$dispatch('frame-external-colour-updated', val);
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'profile': function (val, oldVal) {
                this.update_options();
            },
        },
        mounted() {
            window.emitter.on('door-external-colour-updated', (new_col) => {
                if(this.fabricator === 3 && this.frameMaterial == 2){
                    this.localTarget = new_col;
                }
            });
        },
        onUnmounted() {
            window.emitter.off('door-external-colour-updated');
        },
    }
</script>
